(function () {
    'use strict';

    /**
     * @ngdoc factory
     * @name manageFlights.factory:ManageFlightsAdaptorFactory
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .factory('ManageFlightsAdaptorFactory', ManageFlightsAdaptorFactory);

    function ManageFlightsAdaptorFactory(ManageFlightsRequestFactory) {

        function FlightAdapterDTO() {
            this.flightNo=null;
            this.origin=null;
            this.destination=null;
            this.estimatedDepartureDate=null;
            this.estimatedArrivalDate=null;
            this.estimatedDepartureTime=null;
            this.estimatedArrivalTime=null;
            this.modelNo=null;
            this.FlightLegId=null;
            this.capacity=null;
            this.flightMode=null;
            this.operationType;
        }

        var adaptFlightResults = function (flight) {
            return flight;
        };

        var adaptFlightForEditor = function (flight){
            var disPlayFl = ManageFlightsRequestFactory.getDisplayFlight();
            if(flight!==null){
                disPlayFl.flightNo = flight.flightNo;
                disPlayFl.aircraftModel = {'modelNumber': flight.modelNo};
                disPlayFl.from = { 'airPortCode' : flight.origin };
                disPlayFl.to = { 'airPortCode': flight.destination};
                disPlayFl.fromDate = flight.estimatedDepartureDate;
                disPlayFl.toDate = flight.estimatedArrivalDate;
                disPlayFl.departureTime = flight.estimatedDepartureTime;
                disPlayFl.arrivalTime = flight.estimatedArrivalTime;
                disPlayFl.flightMode = {'value': flight.flightMode, 'title': flight.flightMode};
                disPlayFl.flightLegId =  flight.flightLegId;
                disPlayFl.operationType = flight.operationType;
            }
            return disPlayFl
        };

        var adaptFlightForEdit = function (flight) {
            return {
                aircraftModel: angular.isUndefined(flight.aircraftModel)?null:flight.aircraftModel.modelNumber,
                flightLegId: flight.flightLegId
            }
        }

        return{
            adaptFlightResults: adaptFlightResults,
            adaptFlightForEditor: adaptFlightForEditor,
            adaptFlightForEdit:adaptFlightForEdit
        }
    }
})();
